import * as React from 'react';

// This file will be used for webhook simulation in the future
const WebhookSimulator: React.FC = () => {
  return (
    <div>
      <h1>Webhook Simulator</h1>
      <p>This feature is coming soon.</p>
    </div>
  );
};

export default WebhookSimulator;
